<template>
  <div class="page-contacts tier tier-two">
    <div class="builder-tip">Here is a list of contact details for your website</div>

    <div class="site-contacts">
      <section v-if="hasContacts">
        <table-data :rows="contacts" @rowClick="changeSitePage" :headings="[{heading: '', key: 'edit'}]">
          <div
            v-for="(contact, index) in contacts"
            :slot="'td-' + index + '-edit'"
            :key="index">
            <div class="contact-item">
              <div>
                <Sprite :name="pageIcon(contact)"/>
              </div>
              <span>
                {{ contact.value }}
              </span>
            </div>
          </div>
        </table-data>

        <pagination @changePage="changePage" :pagination="pageData"></pagination>
      </section>

      <section class="tier-content" v-else>
        <div class="helper-text">
          <p>Looks like you don't have any contact options!
            <router-link
              :to="{
                name: 'add-contact',
                params: {companyId: companyId, siteId: siteId}
              }">
              Add your first
            </router-link>.
          </p>
        </div>
      </section>

      <router-link
        :to="{
          name: 'add-contact',
          params: {companyId: companyId, siteId: siteId}
        }"
        class="add-contact-link">
        Add Contact Method
      </router-link>

      <p class="change-contact-email">Want to change the email address that your website contact form submissions go to? You can do that at the company level. <router-link :to="{ name: 'edit-company', params: {userId: currentUser.id, companyId: companyId}}">Change</router-link></p>

      <transition name="column-left">
        <router-view @updatePage="updatePage"/>
      </transition>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'

import {mapState} from 'vuex'

import {readCompanySiteData} from '@/lib/sites'
import {readCompanySiteContactsData} from '@/lib/contacts'

import Table from '@/components/Table'
import Sprite from '@/components/Sprite'

export default {
  name: 'Contacts',

  mixins: [page, pagination, confirm],

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    }
  },

  components: {
    TableData: Table,
    Sprite
  },

  data() {
    return {
      site: {},
      contacts: [],
      sitePage: {}
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })

      readCompanySiteContactsData(this.companyId, this.siteId, this.pagination).then(
        ({data, page}) => {
          this.contacts = data
          this.pageData = page
        }
      )
    },

    updatePage(notification) {
      this.$emit('updatePage', notification)
    },

    changeSitePage(contact) {
      this.$router.push({name: 'contact', params: {contactId: contact.id}})
      this.$emit('changeSitePage', page.path)
    }
  },

  computed: {
    ...mapState(['currentUser']),

    title() {
      return `${this.site.name} Contact Settings`
    },

    hasContacts() {
      return !!this.contacts.length
    },

    pageIcon() {
      return (contact) => {
        switch (contact.key) {
          case 'facebook':
            return 'facebook'
            break // eslint-disable-line no-unreachable
          case 'instagram':
            return 'instagram'
            break // eslint-disable-line no-unreachable
          case 'google':
            return 'google'
            break // eslint-disable-line no-unreachable
          case 'twitter':
            return 'twitter'
            break // eslint-disable-line no-unreachable
          case 'youtube':
            return 'youtube'
            break // eslint-disable-line no-unreachable
          case 'snapchat':
            return 'snapchat'
            break // eslint-disable-line no-unreachable
          case 'linkedin':
            return 'linkedin'
            break // eslint-disable-line no-unreachable
          case 'pinterest':
            return 'pinterest'
            break // eslint-disable-line no-unreachable
          case 'email':
            return 'email'
            break // eslint-disable-line no-unreachable
          case 'phone':
            return 'phone'
            break // eslint-disable-line no-unreachable
          default:
            return 'contact'
        }
      }
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.site-contacts
  .table
    box-shadow: none

  .change-contact-email
    width: 100%
    text-align: center
    white-space: normal
    padding: $gap-medium
    font-size: 10px

  .add-contact-link
    padding: $gap-medium
    border-top: 1px solid $color-border-light
    width: 100%
    text-align: center
    display: block
    text-transform: uppercase

    @include themify($themes)
      color: themed('color-secondary')

.page-contacts
  box-shadow: inset -30px 0px 30px 0px rgba(0, 0, 0, 0.05)

.contact-item
  display: flex
  align-items: center
  text-transform: capitalize

  .sprite
    width: 30px
    height: 30px
    margin-right: $gap-small

    @include themify($themes)
      fill: themed('color-secondary')
</style>
